export enum FileStatus {
	Added,
	Pending,
	Next,
	Progress,
	Success,
	Error,
}
